import { EThemes } from '@/lib/contentstack-sdk/types';
import { ITmHomePlanTemplateCSProps } from './tm-home-plan-detail.types';
import { IExteriorStyle, IHousePlanHit } from '@/lib/search/types';
import {
  EImageIntents,
  EImagePosition,
} from '@/components/atoms/at-media/at-media.types';

export const tmHomePlanTemplateMockBaseElevation: IHousePlanHit = {
  Id: 1,
  Name: 'Santa Barbara American Tradition',
  IsPopular: false,
  IsPreferred: true,
  PopularRank: 1,
  Depth: 40,
  SquareFeet: 2500,
  Width: 30,
  Image: '/assets/olivia.jpg',
  Plan: {
    Name: 'Santa Barbara',
    Id: 101,
    Bathrooms: 3,
    Bedrooms: 4,
    Collection: 'Heritage Collection',
    FlexRoom: true,
    FlexRoomIsBedroom: false,
    HasGarage: true,
    IsMultiGen: false,
    Stories: [{ Id: 1, Name: 'test' }],
    SimilarPlans: [{ SimilarPlanId: 102 }, { SimilarPlanId: 103 }],
  },
  ExteriorStyle: {
    Id: 201,
    Name: 'American Tradition',
    ExteriorStyleCategoryId: 4,
    image: {
      className: 'w-full h-auto',
      roundedCorners: 'md', // assuming 'md' is a valid TAtMediaRoundedSizes value
      src: {
        mobile: '/images/test-mobile.jpg',
        tablet: '/images/test-tablet.jpg',
        desktop: '/images/test-desktop.jpg',
      },
      alt: {
        mobile: 'Test alt for mobile',
        tablet: 'Test alt for tablet',
        desktop: 'Test alt for desktop',
      },
      intent: EImageIntents.DEFAULT, // or DECORATIVE, BRAND, etc.
      position: {
        mobile: EImagePosition.CENTER,
        tablet: EImagePosition.LEFT,
        desktop: EImagePosition.RIGHT,
      },
      priority: true,
      quality: 80,
      decorative: false,
      sizes: '(max-width: 768px) 100vw, 50vw',
      aspectRatio: {
        mobile: '4:3',
        tablet: '16:9',
        desktop: '21:9',
      },
      showOverlay: false,
    },
    Stories: [
      { Id: 1, Name: 'One Story' },
      { Id: 2, Name: 'Optional Bonus' },
    ],
  } as IExteriorStyle,
  HasFloorPlans: true,
  FloorPlans: [],
  IsBaseElevation: true,
  indexName: 'plans_index',
  objectID: 'santa-barbara-at',
  Elevations: [],
  BaseElevationPrice: 450000,
  cms: undefined,
};

export const tmHomePlanTemplateMockData = {
  _content_type_uid: 'home_plan_detail',
  uid: 'bltd40e3ecd6260fa4e',
  locale: 'en-us',
  ACL: {},
  _in_progress: false,
  _version: 48,
  created_at: '2025-03-06T14:28:44.607Z',
  created_by: 'blt8d45334d7e084c9a',
  home_plan_id: {
    select: '31',
  },
  tags: [],
  three_sixty_link: '/3d-link',
  title: 'Charleston',
  updated_at: '2025-03-28T22:20:56.707Z',
  updated_by: 'blt8d45334d7e084c9a',
  home_plan_name: 'Charleston',
  home_plan_hero_section: [
    {
      slide_image: {
        priority: false,
        _metadata: {
          uid: 'cs5e3a5b50d07e1282',
        },
        decorative: true,
        quality: '70',
        mobile_image_url: {
          uid: 'bltc7cd6d6b3be972e8',
          _version: 1,
          title: 'img-3.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-18T19:29:42.585Z',
          updated_at: '2025-03-18T19:29:42.585Z',
          content_type: 'image/jpeg',
          file_size: '9445559',
          filename: 'img-3.jpeg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-18T19:29:53.869Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltc7cd6d6b3be972e8/67d9c9a607d0f96cf65d2c00/img-3.jpeg?branch=develop',
        },
        mobile_position: 'center',
        mobile_aspect_ratio: 'auto',
        tablet_image_url: {
          uid: 'bltc7cd6d6b3be972e8',
          _version: 1,
          title: 'img-3.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-18T19:29:42.585Z',
          updated_at: '2025-03-18T19:29:42.585Z',
          content_type: 'image/jpeg',
          file_size: '9445559',
          filename: 'img-3.jpeg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-18T19:29:53.869Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltc7cd6d6b3be972e8/67d9c9a607d0f96cf65d2c00/img-3.jpeg?branch=develop',
        },
        tablet_position: null,
        tablet_aspect_ratio: null,
        desktop_image_url: {
          uid: 'bltc7cd6d6b3be972e8',
          _version: 1,
          title: 'img-3.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-18T19:29:42.585Z',
          updated_at: '2025-03-18T19:29:42.585Z',
          content_type: 'image/jpeg',
          file_size: '9445559',
          filename: 'img-3.jpeg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-18T19:29:53.869Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltc7cd6d6b3be972e8/67d9c9a607d0f96cf65d2c00/img-3.jpeg?branch=develop',
        },
        desktop_position: 'center',
        desktop_aspect_ratio: null,
      },
    },
    {
      slide_image: {
        priority: false,
        _metadata: {
          uid: 'cs3781a203a319ebe9',
        },
        decorative: true,
        quality: '70',
        mobile_image_url: {
          uid: 'blt26284ac01677a471',
          _version: 1,
          title: 'img-2.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-18T19:28:42.684Z',
          updated_at: '2025-03-18T19:28:42.684Z',
          content_type: 'image/jpeg',
          file_size: '8195194',
          filename: 'img-2.jpeg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-18T19:29:53.885Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blt26284ac01677a471/67d9c96a1c7222056243a161/img-2.jpeg?branch=develop',
        },
        mobile_position: 'center',
        mobile_aspect_ratio: 'auto',
        tablet_image_url: {
          uid: 'blt26284ac01677a471',
          _version: 1,
          title: 'img-2.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-18T19:28:42.684Z',
          updated_at: '2025-03-18T19:28:42.684Z',
          content_type: 'image/jpeg',
          file_size: '8195194',
          filename: 'img-2.jpeg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-18T19:29:53.885Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blt26284ac01677a471/67d9c96a1c7222056243a161/img-2.jpeg?branch=develop',
        },
        tablet_position: null,
        tablet_aspect_ratio: null,
        desktop_image_url: {
          uid: 'blt26284ac01677a471',
          _version: 1,
          title: 'img-2.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-18T19:28:42.684Z',
          updated_at: '2025-03-18T19:28:42.684Z',
          content_type: 'image/jpeg',
          file_size: '8195194',
          filename: 'img-2.jpeg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-18T19:29:53.885Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blt26284ac01677a471/67d9c96a1c7222056243a161/img-2.jpeg?branch=develop',
        },
        desktop_position: 'center',
        desktop_aspect_ratio: null,
      },
    },
    {
      slide_image: {
        priority: false,
        _metadata: {
          uid: 'cs90a09622f8266be1',
        },
        decorative: true,
        quality: '70',
        mobile_image_url: {
          uid: 'bltd80af346911e227b',
          _version: 1,
          title: 'img-1.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-18T19:28:09.313Z',
          updated_at: '2025-03-18T19:28:09.313Z',
          content_type: 'image/jpeg',
          file_size: '8749811',
          filename: 'img-1.jpeg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-18T19:29:53.898Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltd80af346911e227b/67d9c9499c716d280f10c05d/img-1.jpeg?branch=develop',
        },
        mobile_position: 'center',
        mobile_aspect_ratio: 'auto',
        tablet_image_url: {
          uid: 'bltd80af346911e227b',
          _version: 1,
          title: 'img-1.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-18T19:28:09.313Z',
          updated_at: '2025-03-18T19:28:09.313Z',
          content_type: 'image/jpeg',
          file_size: '8749811',
          filename: 'img-1.jpeg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-18T19:29:53.898Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltd80af346911e227b/67d9c9499c716d280f10c05d/img-1.jpeg?branch=develop',
        },
        tablet_position: null,
        tablet_aspect_ratio: null,
        desktop_image_url: {
          uid: 'bltd80af346911e227b',
          _version: 1,
          title: 'img-1.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-18T19:28:09.313Z',
          updated_at: '2025-03-18T19:28:09.313Z',
          content_type: 'image/jpeg',
          file_size: '8749811',
          filename: 'img-1.jpeg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-18T19:29:53.898Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltd80af346911e227b/67d9c9499c716d280f10c05d/img-1.jpeg?branch=develop',
        },
        desktop_position: 'center',
        desktop_aspect_ratio: null,
      },
    },
    {
      slide_image: {
        priority: false,
        _metadata: {
          uid: 'csb87787375032e07a',
        },
        decorative: true,
        quality: '70',
        mobile_image_url: {
          uid: 'blt1393970a7d66c582',
          _version: 1,
          parent_uid: null,
          title: 'promo-block-1.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-05T01:16:19.883Z',
          updated_at: '2025-03-05T01:16:19.883Z',
          content_type: 'image/jpeg',
          file_size: '9507542',
          filename: 'promo-block-1.jpeg',
          ACL: {},
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-05T01:18:43.181Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blt1393970a7d66c582/67c7a5e339a3ca808e111ff5/promo-block-1.jpeg?branch=develop',
        },
        mobile_position: 'center',
        mobile_aspect_ratio: 'auto',
        tablet_image_url: {
          uid: 'blt6cb76f5435a70047',
          _version: 1,
          parent_uid: null,
          title: 'promo-block-2.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-05T01:16:19.696Z',
          updated_at: '2025-03-05T01:16:19.696Z',
          content_type: 'image/jpeg',
          file_size: '1944148',
          filename: 'promo-block-2.jpeg',
          ACL: {},
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-05T01:28:27.843Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blt6cb76f5435a70047/67c7a5e354cf2ffe8476760e/promo-block-2.jpeg?branch=develop',
        },
        tablet_position: null,
        tablet_aspect_ratio: null,
        desktop_image_url: {
          uid: 'blt6cb76f5435a70047',
          _version: 1,
          parent_uid: null,
          title: 'promo-block-2.jpeg',
          created_by: 'blt9d38ef245c24d64c',
          updated_by: 'blt9d38ef245c24d64c',
          created_at: '2025-03-05T01:16:19.696Z',
          updated_at: '2025-03-05T01:16:19.696Z',
          content_type: 'image/jpeg',
          file_size: '1944148',
          filename: 'promo-block-2.jpeg',
          ACL: {},
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-05T01:28:27.843Z',
            user: 'blt9d38ef245c24d64c',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blt6cb76f5435a70047/67c7a5e354cf2ffe8476760e/promo-block-2.jpeg?branch=develop',
        },
        desktop_position: 'center',
        desktop_aspect_ratio: null,
      },
    },
    {
      slide_image: {
        priority: false,
        _metadata: {
          uid: 'cs546fca39adfce341',
        },
        decorative: true,
        quality: '70',
        mobile_image_url: {
          uid: 'blted3fc3e6eb10a9ed',
          _version: 1,
          title: 'half-page-media-desktop.jpg',
          created_by: 'blt8dcc408130de2249',
          updated_by: 'blt8dcc408130de2249',
          created_at: '2025-03-07T20:26:51.386Z',
          updated_at: '2025-03-07T20:26:51.386Z',
          content_type: 'image/jpeg',
          file_size: '400089',
          filename: 'half-page-media-desktop.jpg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-07T20:27:01.469Z',
            user: 'blt8dcc408130de2249',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blted3fc3e6eb10a9ed/67cb568b3661f252beccbc37/half-page-media-desktop.jpg?branch=develop',
        },
        mobile_position: 'center',
        mobile_aspect_ratio: 'auto',
        tablet_image_url: {
          uid: 'blted3fc3e6eb10a9ed',
          _version: 1,
          title: 'half-page-media-desktop.jpg',
          created_by: 'blt8dcc408130de2249',
          updated_by: 'blt8dcc408130de2249',
          created_at: '2025-03-07T20:26:51.386Z',
          updated_at: '2025-03-07T20:26:51.386Z',
          content_type: 'image/jpeg',
          file_size: '400089',
          filename: 'half-page-media-desktop.jpg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-07T20:27:01.469Z',
            user: 'blt8dcc408130de2249',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blted3fc3e6eb10a9ed/67cb568b3661f252beccbc37/half-page-media-desktop.jpg?branch=develop',
        },
        tablet_position: null,
        tablet_aspect_ratio: null,
        desktop_image_url: {
          uid: 'blted3fc3e6eb10a9ed',
          _version: 1,
          title: 'half-page-media-desktop.jpg',
          created_by: 'blt8dcc408130de2249',
          updated_by: 'blt8dcc408130de2249',
          created_at: '2025-03-07T20:26:51.386Z',
          updated_at: '2025-03-07T20:26:51.386Z',
          content_type: 'image/jpeg',
          file_size: '400089',
          filename: 'half-page-media-desktop.jpg',
          ACL: {},
          parent_uid: null,
          is_dir: false,
          tags: [],
          publish_details: {
            time: '2025-03-07T20:27:01.469Z',
            user: 'blt8dcc408130de2249',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blted3fc3e6eb10a9ed/67cb568b3661f252beccbc37/half-page-media-desktop.jpg?branch=develop',
        },
        desktop_position: 'center',
        desktop_aspect_ratio: null,
      },
    },
    {
      slide_image: {
        priority: false,
        _metadata: {
          uid: 'csef7908d0df5a538e',
        },
        decorative: true,
        quality: '70',
        mobile_image_url: {
          uid: 'bltad41e69e8f9e9929',
          _version: 2,
          ACL: {},
          content_type: 'image/png',
          created_at: '2025-02-01T13:43:44.199Z',
          created_by: 'blt8d45334d7e084c9a',
          file_size: '1623766',
          filename: 'test.png',
          is_dir: false,
          parent_uid: null,
          tags: [],
          title: 'test.png',
          updated_at: '2025-03-17T15:18:38.357Z',
          updated_by: 'blt81b1cadb0cbd06e9',
          publish_details: {
            time: '2025-03-25T19:39:58.700Z',
            user: 'blt8dcc408130de2249',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltad41e69e8f9e9929/679e25104405defe114af1fa/test.png?branch=develop',
        },
        mobile_position: 'center',
        mobile_aspect_ratio: 'auto',
        tablet_image_url: {
          uid: 'bltad41e69e8f9e9929',
          _version: 2,
          ACL: {},
          content_type: 'image/png',
          created_at: '2025-02-01T13:43:44.199Z',
          created_by: 'blt8d45334d7e084c9a',
          file_size: '1623766',
          filename: 'test.png',
          is_dir: false,
          parent_uid: null,
          tags: [],
          title: 'test.png',
          updated_at: '2025-03-17T15:18:38.357Z',
          updated_by: 'blt81b1cadb0cbd06e9',
          publish_details: {
            time: '2025-03-25T19:39:58.700Z',
            user: 'blt8dcc408130de2249',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltad41e69e8f9e9929/679e25104405defe114af1fa/test.png?branch=develop',
        },
        tablet_position: null,
        tablet_aspect_ratio: null,
        desktop_image_url: {
          uid: 'bltad41e69e8f9e9929',
          _version: 2,
          ACL: {},
          content_type: 'image/png',
          created_at: '2025-02-01T13:43:44.199Z',
          created_by: 'blt8d45334d7e084c9a',
          file_size: '1623766',
          filename: 'test.png',
          is_dir: false,
          parent_uid: null,
          tags: [],
          title: 'test.png',
          updated_at: '2025-03-17T15:18:38.357Z',
          updated_by: 'blt81b1cadb0cbd06e9',
          publish_details: {
            time: '2025-03-25T19:39:58.700Z',
            user: 'blt8dcc408130de2249',
            environment: 'blt901eff50b24bab9c',
            locale: 'en-us',
          },
          url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltad41e69e8f9e9929/679e25104405defe114af1fa/test.png?branch=develop',
        },
        desktop_position: 'center',
        desktop_aspect_ratio: null,
      },
    },
    {
      cta_slide: {
        slide_content: [
          {
            cta: {
              label: 'CTA to TEST',
              _metadata: {
                uid: 'cs5415af32fc186ca0',
              },
              url: {
                title: 'CTA to TEST',
                href: '/',
              },
              aria_label: '',
              type: 'cta',
              variant: 'PRIMARY',
              target: 'SELF',
              outline: true,
              size: 'LG',
              icon: [],
            },
          },
          {
            slide_image: {
              priority: false,
              _metadata: {
                uid: 'csf8aae80119ad6ae1',
              },
              decorative: true,
              quality: '70',
              mobile_image_url: {
                uid: 'bltc280677c5da9a9e5',
                _version: 1,
                title: 'img-4.jpeg',
                created_by: 'blt9d38ef245c24d64c',
                updated_by: 'blt9d38ef245c24d64c',
                created_at: '2025-03-18T20:04:14.727Z',
                updated_at: '2025-03-18T20:04:14.727Z',
                content_type: 'image/jpeg',
                file_size: '8677702',
                filename: 'img-4.jpeg',
                ACL: {},
                parent_uid: null,
                is_dir: false,
                tags: [],
                publish_details: {
                  time: '2025-03-18T20:04:28.943Z',
                  user: 'blt9d38ef245c24d64c',
                  environment: 'blt901eff50b24bab9c',
                  locale: 'en-us',
                },
                url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltc280677c5da9a9e5/67d9d1bece729c4d63ae32fa/img-4.jpeg?branch=develop',
              },
              mobile_position: 'center',
              mobile_aspect_ratio: 'auto',
              tablet_image_url: {
                uid: 'bltc280677c5da9a9e5',
                _version: 1,
                title: 'img-4.jpeg',
                created_by: 'blt9d38ef245c24d64c',
                updated_by: 'blt9d38ef245c24d64c',
                created_at: '2025-03-18T20:04:14.727Z',
                updated_at: '2025-03-18T20:04:14.727Z',
                content_type: 'image/jpeg',
                file_size: '8677702',
                filename: 'img-4.jpeg',
                ACL: {},
                parent_uid: null,
                is_dir: false,
                tags: [],
                publish_details: {
                  time: '2025-03-18T20:04:28.943Z',
                  user: 'blt9d38ef245c24d64c',
                  environment: 'blt901eff50b24bab9c',
                  locale: 'en-us',
                },
                url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltc280677c5da9a9e5/67d9d1bece729c4d63ae32fa/img-4.jpeg?branch=develop',
              },
              tablet_position: null,
              tablet_aspect_ratio: null,
              desktop_image_url: {
                uid: 'bltc280677c5da9a9e5',
                _version: 1,
                title: 'img-4.jpeg',
                created_by: 'blt9d38ef245c24d64c',
                updated_by: 'blt9d38ef245c24d64c',
                created_at: '2025-03-18T20:04:14.727Z',
                updated_at: '2025-03-18T20:04:14.727Z',
                content_type: 'image/jpeg',
                file_size: '8677702',
                filename: 'img-4.jpeg',
                ACL: {},
                parent_uid: null,
                is_dir: false,
                tags: [],
                publish_details: {
                  time: '2025-03-18T20:04:28.943Z',
                  user: 'blt9d38ef245c24d64c',
                  environment: 'blt901eff50b24bab9c',
                  locale: 'en-us',
                },
                url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/bltc280677c5da9a9e5/67d9d1bece729c4d63ae32fa/img-4.jpeg?branch=develop',
              },
              desktop_position: 'center',
              desktop_aspect_ratio: null,
            },
          },
          {
            header: {
              header: 'Launch Tour',
            },
          },
        ],
        _metadata: {
          uid: 'cs23bebf408f2dc1bd',
        },
      },
    },
    {
      autoplay: {
        autoplay: false,
      },
    },
  ],
  home_plan_details: {
    copy_block: {
      alt_header: false,
      alignment: { alignmentprop: 'CENTER' },
      theme: { theme: EThemes.DARK },
      _content_type_uid: 'copy_block',
      description:
        "<ul><li>The spacious kitchen features ample counter and cabinet space, a large island for gatherings, and a walk-in pantry</li><li>Convenient pocket office provides a dedicated workspace for organization and productivity</li><li>Luxurious Owner's Retreat includes a spacious bathroom, dual walk-in closets, and easy access from the office</li><li>Plenty of private space for everyone in the family</li></ul>",
      heading_element: 'h2',
      heading_variant: 'h2',
      link: {
        aria_label: '',
        icon: [],
        outline: false,
        size: 'LG',
        label: '',
        target: 'BLANK',
        type: 'cta',
        url: {
          title: '',
          href: '',
        },
        variant: 'PRIMARY',
      },
      title: 'About this Plan',
    },
  },
  model_home_details: {
    image: {
      decorative: false,
      desktop_aspect_ratio: null,
      desktop_image_url: null,
      desktop_position: null,
      mobile_aspect_ratio: 'auto',
      mobile_image_url: {
        uid: 'blt1393970a7d66c582',
        _version: 1,
        parent_uid: null,
        title: 'promo-block-1.jpeg',
        created_by: 'blt9d38ef245c24d64c',
        updated_by: 'blt9d38ef245c24d64c',
        created_at: '2025-03-05T01:16:19.883Z',
        updated_at: '2025-03-05T01:16:19.883Z',
        content_type: 'image/jpeg',
        file_size: '9507542',
        filename: 'promo-block-1.jpeg',
        ACL: {},
        is_dir: false,
        tags: [],
        publish_details: {
          time: '2025-03-05T01:18:43.181Z',
          user: 'blt9d38ef245c24d64c',
          environment: 'blt901eff50b24bab9c',
          locale: 'en-us',
        },
        url: 'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blt1393970a7d66c582/67c7a5e339a3ca808e111ff5/promo-block-1.jpeg?branch=develop',
      },
      mobile_position: 'center',
      priority: false,
      quality: '75',
      tablet_aspect_ratio: null,
      tablet_image_url: null,
      tablet_position: null,
    },
    events_link: {
      aria_label: '',
      icon: [],
      label: 'See Upcoming Events',
      outline: false,
      size: 'LG',
      target: 'SELF',
      type: 'isolatedLink',
      url: {
        title: 'See Upcoming Events',
        href: '/',
      },
      variant: 'SECONDARY',
    },
    visit_link: {
      aria_label: '',
      icon: [],
      label: 'Plan a Visit',
      outline: false,
      size: 'LG',
      target: 'SELF',
      type: 'cta',
      url: {
        title: 'Plan a Visit',
        href: '/',
      },
      variant: 'PRIMARY',
    },
  },
  body: [],
  has_three_d: true,
  publish_details: {
    time: '2025-03-28T22:21:17.451Z',
    user: 'blt8d45334d7e084c9a',
    environment: 'blt901eff50b24bab9c',
    locale: 'en-us',
  },
  url: '',
} as ITmHomePlanTemplateCSProps;
